<template>
  <div class="language-dropdown">
    <ul class="language-dropdown__list">
      <li
        v-for="item in languages"
        :key="item.abbreviation"
        class="language-dropdown__item"
        :class="{ 'is-active': isActiveLanguage(item.abbreviation) }"
        @click="selectedLanguage(item.abbreviation)"
      >
        <span
          class="language-dropdown__badge"
          :style="{ backgroundColor: badgeColor(item.abbreviation) }"
        >
          {{ item.abbreviation.slice(0, 2).toUpperCase() }}
        </span>
        <span class="language-dropdown__name">{{ item.name }}</span>
        <v-icon
          v-if="isActiveLanguage(item.abbreviation)"
          size="18"
          color="primary"
          class="ms-auto"
        >
          mdi-check-circle
        </v-icon>
      </li>
    </ul>
  </div>
</template>

<script>
import i18nService from "@/core/services/i18n.service.js";

const BADGE_COLORS = {
  en: "#7e04b7",
  ar: "#ffa800",
  ch: "#fd397a",
  es: "#0abb87",
  jp: "#5578eb",
  de: "#5d78ff",
  fr: "#3699ff",
};

export default {
  name: "KTDropdownLanguage",
  data() {
    return {
      languages: i18nService.languageslist,
      // Mirror the persisted language as reactive state so the active
      // row updates immediately on selection. localStorage reads are
      // non-reactive, so a `computed` over `getActiveLanguage()` would
      // stay stuck on whatever value was present at first render.
      activeLanguage: i18nService.getActiveLanguage(),
    };
  },
  mounted() {
    i18nService.setActiveLanguage(i18nService.getActiveLanguage());
    this.$vuetify.rtl = i18nService.isRTL();
    this.activeLanguage = i18nService.getActiveLanguage();
  },
  methods: {
    badgeColor(lang) {
      return BADGE_COLORS[lang] || "#7e04b7";
    },
    selectedLanguage(lang) {
      i18nService.setActiveLanguage(lang);
      this.$vuetify.rtl = i18nService.isRTL();
      this.activeLanguage = lang;
      this.$emit(
        "language-changed",
        this.languages.find((val) => val.abbreviation === lang)
      );
    },
    isActiveLanguage(current) {
      return this.activeLanguage === current;
    },
  },
};
</script>

<style lang="scss" scoped>
.language-dropdown {
  padding: 0.5rem 0.75rem;
  min-width: 220px;
}

.language-dropdown__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.language-dropdown__item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
  margin-bottom: 0.25rem;

  &:hover {
    background-color: #f3f4f8;
  }

  &.is-active {
    background-color: #f5e9fc;
    font-weight: 600;
  }
}

.language-dropdown__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 0.5rem;
  color: #ffffff;
  font-weight: 700;
  font-size: 0.8rem;
  flex-shrink: 0;
}

.language-dropdown__name {
  color: #3f4254;
  font-size: 0.95rem;
}
</style>
